export interface HashScrollTarget {
  scrollIntoView: (options?: ScrollIntoViewOptions) => void
}

export interface HashScrollDocument {
  querySelector: (selector: string) => HashScrollTarget | null
}

/** StudioLayout scrolls its pane, not the window — native #anchors never move. */
export function scrollDesktopHashIntoView(
  hash: string,
  doc: HashScrollDocument = globalThis.document,
): boolean {
  let id: string
  try {
    id = decodeURIComponent(hash.replace(/^#/, ''))
  } catch {
    return true
  }

  if (!id || !/^[A-Za-z][\w-]*$/.test(id)) {
    return true
  }

  const target = doc.querySelector(`#${id}`)
  if (!target) {
    return false
  }

  target.scrollIntoView({ behavior: 'smooth', block: 'start' })
  return true
}
